import { gsap } from '../global/gsap';

const initMenu = (element) => {
    const body = document.querySelector('.js-body');
    const menuToggles = document.querySelectorAll('.js-menu-button');
    const subMenus = element.querySelectorAll('.js-sub-menu');
    const navButtons = element.querySelectorAll('.js-menu-highlight');
    const followEl = element.querySelector('.js-highlight');
    const navContainer = element.querySelector('.primary-nav__list');
    const headerInner = element.querySelector('.js-header-inner');
    const menuBGs = element.querySelectorAll('.js-menu-bgs');
    const searchToggle = element.querySelector('.js-search-toggle');
    const searchInput = element.querySelector('.js-search-input');
    const mmenuScroll = element.querySelector('.js-menu-scroll');

    const hasSubMenuEls = element.querySelectorAll('.js-has-sub-menu');
    const subMenuBG = document.querySelector('.js-primary-bg');

    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'menu-is-active';
    let menuActive = false;
    let searchActive = false;

    let navSetter = null;
    let searchCloseTimeout = null;

    const updateMenuWidths = () => {
        const hoverImageWidth = headerInner.offsetWidth - navContainer.offsetWidth + 1;
        menuBGs.forEach((bg) => {
            bg.style.width = `${hoverImageWidth}px`;
        });
    };

    const resizeObserver = new ResizeObserver(() => {
        window.requestAnimationFrame(updateMenuWidths);
    });

    resizeObserver.observe(headerInner);
    updateMenuWidths();

    gsap.set(subMenuBG, { autoAlpha: 0 });

    const showBG = () => {
        if (searchActive) return;
        gsap.to(subMenuBG, {
            autoAlpha: 0.8,
            duration: 0.3,
            ease: 'power2.out',
            overwrite: true,
        });
    };

    const hideBG = () => {
        if (searchActive) return;
        gsap.to(subMenuBG, {
            autoAlpha: 0,
            duration: 0.3,
            ease: 'power2.inOut',
            overwrite: true,
        });
    };

    hasSubMenuEls.forEach((el) => {
        el.addEventListener('mouseenter', showBG);
        el.addEventListener('mouseleave', hideBG);
    });

    // const menuItems = element.querySelectorAll('.js-menu-item');
    // const menuOverlayContent = element.querySelector('.js-menu-content');
    const menuContent = element.querySelector('.js-overlay-menu');

    const menuTimeline = gsap.timeline({
        paused: true,
        onStart: () => { menuContent.scrollTop = 0; },
        defaults: { ease: 'power1.out', duration: 0.4 },
    });

    // gsap.set(menuOverlayContent, { x: 140 });

    // menuTimeline.to(menuOverlayContent, {
    //     x: 0
    // });

    // menuTimeline.to(menuOverlayContent, { x: 0 })
    // .from(menuItems, {
    //     opacity: 0,
    //     stagger: 0.05,
    //     duration: 0.3,
    // }, '-=0.2');

    const closeMenu = () => {
        menuActive = false;
        body.classList.remove(stopScrollingClass, isActiveClass);
        menuTimeline.reverse();
    };

    const closeSearch = () => {
        searchActive = false;
        body.classList.remove('search-active');
        gsap.to(subMenuBG, { autoAlpha: 0, duration: 0.3, overwrite: true });
        if (navSetter) {
            navSetter.xPosition(0);
            navSetter.width('7rem');
        }
    };

    menuToggles.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            menuActive = !menuActive;
            closeSearch();
            if (menuActive) {
                body.classList.add(stopScrollingClass, isActiveClass);
                menuTimeline.play();
            } else {
                closeMenu();
            }
        });
    });

    mmenuScroll.addEventListener('click', (e) => {
        if (e.target === mmenuScroll) {
            body.classList.remove(stopScrollingClass, isActiveClass);
            menuTimeline.reverse();
        }
    });

    subMenus.forEach((menu) => {
        const navLinks = menu.querySelectorAll('.primary-nav__sub-menu-list a');
        const bgItems = menu.querySelectorAll('.primary-nav__sub-menu-bgs li');

        navLinks.forEach((link) => {
            link.addEventListener('mouseenter', () => {
                if (searchActive) return;
                if (menuActive) return;
                body.classList.add(stopScrollingClass);
                const index = link.getAttribute('data-index');
                bgItems.forEach((item) => item.classList.remove('is-active'));
                bgItems[index].classList.add('is-active');
            });
        });
    });

    const updateThisNav = (targetEl) => {
        if (!navSetter || !targetEl) return;
        const parentRect = headerInner.getBoundingClientRect();
        const targetRect = targetEl.getBoundingClientRect();
        const relativeX = targetRect.left - parentRect.left;
        const targetWidth = targetRect.width;

        navSetter.xPosition(relativeX);
        navSetter.width(targetWidth);
        element.classList.add('submenu-is-active');
    };

    const mm = gsap.matchMedia();
    mm.add('(min-width: 901px)', () => {
        navSetter = {
            xPosition: gsap.quickTo(followEl, 'x', { duration: 0.5, ease: 'power3.out' }),
            // width: gsap.quickTo(followEl, 'width', { duration: 0.5, ease: 'power3.out' }),
            width: (val) => gsap.to(followEl, { width: val, duration: 0.5, ease: 'power3.out' }),
        };

        navButtons.forEach((button) => {
            button.addEventListener('mouseenter', () => {
                if (searchActive && button !== searchToggle) {
                    searchCloseTimeout = setTimeout(() => {
                        searchActive = false;
                        body.classList.remove('search-active');
                    }, 2000);
                }
                updateThisNav(button);
            });
        });

        navContainer.addEventListener('mouseleave', () => {
            // if search is active, don't let the nav list mouseleave reset things
            if (searchActive) return;
            if (menuActive) return;

            body.classList.remove(stopScrollingClass);
            if (navButtons.length > 0) {
                navSetter.xPosition(0);
                navSetter.width('7rem');
                element.classList.remove('submenu-is-active');
            }
        });

        if (navButtons.length > 0) {
            navSetter.xPosition(0);
            navSetter.width('7rem');
        }
    });

    // close search and hide everything if the mouse leaves the header
    headerInner.addEventListener('mouseleave', () => {
        if (searchActive) {
            searchActive = false;
            body.classList.remove('search-active', stopScrollingClass);
            closeSearch();
        }
    });

    searchToggle.addEventListener('click', (e) => {
        e.preventDefault();

        if (searchCloseTimeout) {
            clearTimeout(searchCloseTimeout);
            searchCloseTimeout = null;
        }

        searchActive = !searchActive;

        if (searchActive) {
            closeMenu();
            body.classList.add('search-active');
            gsap.to(subMenuBG, { autoAlpha: 0.8, duration: 0.3, overwrite: true });
            updateThisNav(searchToggle);
            if (searchInput) {
                searchInput.focus();
            }
        } else {
            closeSearch();
        }
    });
};

export { initMenu as default };
